import type { ProductsContext } from "@/lib/api/generated/casedb";
import type { CaseReviewCollectionApi } from "../../shared/hooks/useCaseReview";

/** The intake snapshot is read-only and follows the selected product. */
export function useProductCodedIndication(api: CaseReviewCollectionApi, sectionContext: unknown): string | null {
  const context = sectionContext as ProductsContext | undefined;
  return context?.products?.find(row => row.record_id === api.selectedId)?.coded_indication ?? null;
}
